import { appFaultModel } from "@/core/modules/appFault/models/AppFaultModel";

export class DoctorHelpers {
  public static getFolderPath(doctorId: string | undefined): string {
    try {
      if (doctorId === undefined) throw new Error("doctorId is undefined");
      return `doctors/${doctorId}/`;
    } catch (error: unknown) {
      appFaultModel.catchAppError("DoctorHelpers.getFolderPath", { doctorId }, error);
      throw error;
    }
  }
}
